/**
 * On web or mWeb we can simply refresh the page and the user should have the new version of the app downloaded.
 */
export default function updateApp() {
    window.location.reload();
}
